export const EXTRA_MENU_TYPE = 'extra-menu';
export const OUR_MODELS_TYPE = 'our-models';
export const STICKY_HEADER_HEIGHT_DEFAULT = 80;
export const STICKY_HEADER_HEIGHT_MOBILE = 64;
export const MAX_HEIGHT_MENU = '650px';
export const HEADER_PORTAL_ID = 'header-portal';
